import React from "react";

export default function BcLogo() {
  return (
    <div
      className={"flex flex-row items-center leading-none text-white"}
    >
      <img src="/brandingcompass-r-logo.png" width={166} height={46}  alt={"Logo"}/>
    </div>
  );
}
